<script lang="ts">import { ranksDataRocketbet } from "../../data";
import Included from "../../icons/included.svelte";
import { cfgBrand, cfgBrandTitle } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { hexToRgba, isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Icon } from "@infinitro/rank-badges";
import VipTitle from "./vip-title.svelte";
export let isPadding = true;
const BRAND_NAME = cfgBrandTitle();
let rows = [
	{
		name: Verbiage.rakeback,
		id: "rakeback"
	},
	{
		name: Verbiage.rakeboost,
		id: "rakeboost"
	},
	{
		name: Verbiage.level_up_reward_text,
		id: "level-up-reward"
	},
	{
		name: Verbiage.daily_bonus_text,
		id: "daily-bonus"
	},
	{
		name: Verbiage.weekly_bonus_text,
		id: "weekly-bonus"
	},
	{
		name: Verbiage.monthly_bonus_text,
		id: "monthly-bonus"
	},
	{
		name: Verbiage.vip_races,
		id: "vip-races"
	},
	{
		name: Verbiage.vip_payouts,
		id: "vip-payouts"
	},
	{
		name: Verbiage.dedicated_vip_host_text,
		id: "dedicated-vip-host"
	},
	{
		name: Verbiage.tailored_bonus_plan,
		id: "tailored-bonus-plan"
	},
	{
		name: Verbiage.brand_events,
		id: "brand-events"
	}
];
</script>

<div class="vip-ranks-table-container">
	<VipTitle title={$t(Verbiage.vip_rank_rewards)} />
	<InfoCard width="100%" borderRadius="20px" noPadding>
		<div class="vip-rank-rewards" class:withPadding={!$isMobile && isPadding}>
			<div class="vip-rank-rewards-container">
				<div class="table-container">
					<div class="ranks-reward-table">
						<div class="table-header">
							{#each ranksDataRocketbet as rank, tierIndex}
								<div class="header-cell">
									<div class="badge-container">
										<Icon rank={tierIndex + 1} level={0} size={40} />
									</div>
									<span>{rank.name}</span>
								</div>
							{/each}
						</div>
						{#key $isMobile}
							<div class="table-body">
								<div
									class="table-side"
									style={$isMobile
										? "background: {hexToRgba('var(--color-background-900)', 50)}"
										: ''}
								>
									{#each rows as row, i}
										<div class="side-cell" class:cell-odd={i % 2 === 0}>
											{@html $t(row.name)?.replace('[BRAND]', BRAND_NAME)}
										</div>
									{/each}
								</div>
								<div class="table-content">
									{#each rows as row, i}
										<div class="content-row" class:cell-odd={i % 2 === 0}>
											{#each ranksDataRocketbet as rank}
												<div class="content-cell">
													{#if rank.rewards.includes(row.id)}
														<Included useAlternative2={true} />
													{/if}
												</div>
											{/each}
										</div>
									{/each}
								</div>
							</div>
						{/key}
					</div>
				</div>
			</div>
		</div>
	</InfoCard>
</div>

<style>
	.vip-ranks-table-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 2rem;
}

	.withPadding {
		padding: 1rem;
		padding-top: 0px;
}

	.vip-rank-rewards {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
}

	.vip-rank-rewards-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border-radius: 9999px;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		background: var(--gradient-main);
}

	.vip-rank-rewards-container {
		position: relative;
		max-width: 92vw;
}

	@media (min-width: 1024px) {

		.vip-rank-rewards-container {
				width: 100%;
		}
}

	.table-container {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: thin;
		scrollbar-color: var(--color-neutral-900) var(--color-background-900);
}

	.table-container::-webkit-scrollbar {
		height: 0.5rem;
		width: 0.5rem;
		background-color: transparent;
		display: block;
}

	.table-container::-webkit-scrollbar-track {
		background-color: var(--color-background-900);
}

	.table-container::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: var(--color-neutral-900);
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
}

	@media (max-width: 768px) {
		.table-container {
			overflow-x: scroll;
			-ms-overflow-style: -ms-autohiding-scrollbar;
		}

		.table-container::-webkit-scrollbar {
			-webkit-appearance: none;
			height: 4px;
		}
	}

	.ranks-reward-table {
		width: 100%;
		min-width: 1200px;
		border-radius: 0.5rem;
}
	@media (min-width: 1024px) {
		.ranks-reward-table {
				min-width: 0px;
		}
	}

	.table-header {
		display: flex;
		height: 88px;
		align-items: center;
		justify-content: space-between;
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 105px;
		padding-right: 5px;
		z-index: 5;
		position: relative;
}

	.header-cell {
		display: flex;
		width: 9%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		font-size: 0.75rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}

	.badge-container {
		display: flex;
		height: 40px;
		width: 40px;
		align-items: center;
		justify-content: center;
}

	.table-body {
		display: flex;
}

	.table-side {
		display: flex;
		width: 100px;
		flex-direction: column;
		border-bottom-left-radius: 0.5rem;
		position: absolute;
		z-index: 10;
		transform: translateX(-1px);
		top: 88px;
}

	.side-cell {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.5rem;
		font-size: 11px;
		font-weight: 600;
		--tw-backdrop-blur: blur(30px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		font-family: var(--font-main);
}
	.cell-odd {
		background-color: var(--color-background-500) !important;
}

	.table-content {
		display: flex;
		width: 100%;
		flex-direction: column;
}

	.content-row {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		padding-left: 105px;
}

	.content-row:nth-child(odd) {
		background-color: transparent;
}

	.content-cell {
		display: flex;
		width: 9.5%;
		align-items: center;
		justify-content: center;
		padding: 0.5rem;
		text-align: left;
		font-size: 0.75rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
</style>
